// components/CustomWidgets.jsx
import React from 'react';
/* React Icons */
import { RiQuestionAnswerLine, RiRobot2Fill } from "react-icons/ri";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaPuzzlePiece } from "react-icons/fa";

const sampleData = {
  categories: { count: 24, icon: <FaPuzzlePiece />, label: 'Coaching Categories' },
  subscribers: { count: 1842, icon: <BsFillPeopleFill />, label: 'User Subscribers' },
  questions: { count: 567, icon: <RiQuestionAnswerLine />, label: 'Common Questions' },
  instructions: { count: 567, icon: <RiRobot2Fill />, label: 'ARI Instructions' }
};

const CustomWidgets = () => {
    const widgets = [
        { id: 1, title: sampleData.categories.label, count: sampleData.categories.count, icon: sampleData.categories.icon },
        { id: 2, title: sampleData.subscribers.label, count: sampleData.subscribers.count, icon: sampleData.subscribers.icon },
        { id: 3, title: sampleData.questions.label, count: sampleData.questions.count, icon: sampleData.questions.icon },
        { id: 4, title: sampleData.instructions.label, count: sampleData.instructions.count, icon: sampleData.instructions.icon }
    ];

    return (
        <div className="dbmm-widgets-container">
            <h3 className="dbmm-section-title">Overview</h3>
            <div className="mm-row">
                {widgets.map(widget => (
                    <div key={widget.id} className="mm-col-xs-12 mm-col-md-6 mm-col-lg-6">
                        <div className="dbmm-widget-card">
                            <div className="dbmm-widget-icon">{widget.icon}</div>
                            <div className="dbmm-widget-info">
                                <span className="dbmm-widget-count">{widget.count.toLocaleString()}</span>
                                <span className="dbmm-widget-title">{widget.title}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomWidgets;